module.exports = __webpack_public_path__ + "static/media/amazonwebservices-original.0292ec4e.svg";